import * as React from "react";
import { Accordion as BaseAccordion } from "@base-ui/react/accordion";
import { cn } from "@/lib/utils";

interface AccordionProps {
	children: React.ReactNode;
	className?: string;
}

/**
 * Root accordion component that wraps accordion items.
 *
 * @param children - Accordion items to render.
 */
export const Accordion: React.FC<AccordionProps> = ({ children, className }) => {
	return <BaseAccordion.Root className={cn("flex flex-col w-full", className)}>{children}</BaseAccordion.Root>;
};

export { AccordionItem } from "./item";
